const TAX_EVENTS = {
    TAX_APPLIED: 'tax_applied',
} as const;

const CUSTOMER_EVENTS = {
    ADD_CUSTOMER: 'click_add_customer',
} as const;

const CHECKOUT_EVENTS = {
    PROCEED_TO_CHECKOUT: 'click_checkout',
} as const;

const CART_EVENTS = {
    CART_CREATED: 'cart_created',
    CART_ITEM_ADDED: 'cart_item_added',
    CART_ITEM_REMOVED: 'cart_item_removed',
    CART_ITEM_QUANTITY_CHANGED: 'cart_item_quantity_changed',
    CART_VOIDED: 'cart_voided',
    CART_COMPLETED: 'cart_completed',
    CART_SAVED: 'cart_saved',
    CART_RESUMED: 'cart_resumed',
    CART_DELETED: 'saved_cart_deleted',
    CART_DISCOUNT_ADDED: 'cart_discount_applied',
} as const;

const REPORT_EVENTS = {
    PRINT_SALES_SUMMARY: 'print_sales_summary_report',
    PRINT_SALES_BY_ITEM: 'print_sales_by_item_report',
    PRINT_SALES_BY_CATEGORY: 'print_sales_by_category_report',
    PRINT_SALES_BY_PAYMENT_METHOD: 'print_sales_by_payment_method_report',
} as const;

const BRANCH_EVENTS = {
    CLICK_SWITCH_BRANCH: 'click_switch_branch',
    SELECT_BRANCH: 'select_branch',
} as const;

const AUTH_EVENTS = {
    REGISTER_LOGIN_SUCCESSFUL: 'register_login_successful',
    REGISTER_LOGIN_FAILED: 'register_login_failed',
} as const;

const PAYMENT_EVENTS = {
    CLICK_COMPLETED_PAYMENT: 'click_completed_payment',
} as const;

const LOGOUT_EVENTS = {
    STAFF_LOGOUT: 'staff_logout',
} as const;

export const REGISTER_EVENTS = {
    TAX: TAX_EVENTS,
    CUSTOMER: CUSTOMER_EVENTS,
    CHECKOUT: CHECKOUT_EVENTS,
    CART: CART_EVENTS,
    REPORT: REPORT_EVENTS,
    BRANCH: BRANCH_EVENTS,
    AUTH: AUTH_EVENTS,
    PAYMENT: PAYMENT_EVENTS,
    LOGOUT: LOGOUT_EVENTS,
} as const;

export const CART_ITEM_ADD_METHOD = {
    QuickAdd: 'quick_add',
    Search: 'search',
    Manual: 'manual',
    Scan: 'scan',
} as const;

export type CartItemAddMethod =
    (typeof CART_ITEM_ADD_METHOD)[keyof typeof CART_ITEM_ADD_METHOD];

export const QUANTITY_CHANGE_DIRECTION = {
    Increase: 'increase',
    Decrease: 'decrease',
} as const;

export type QuantityChangeDirection =
    (typeof QUANTITY_CHANGE_DIRECTION)[keyof typeof QUANTITY_CHANGE_DIRECTION];

export const AUDIT_LOG_EVENTS = {
    FAILED_APPEND: 'failed_append',
} as const;

export const SALE_LOG_EVENT = 'initiate-sale';

export const DB_MIGRATION_LOG_EVENT = 'db-migration';

export const FIRESTORE_LOG_EVENT = 'firestore';

export const STOCK_LOG_EVENT = 'stock-tracker';
